import { useEffect } from "react"
import { Button, Form, Input, Modal, Upload } from "antd"
import type { UploadFile } from "antd/es/upload/interface"
import { InboxOutlined } from "@ant-design/icons"
import { FileAssetFormData, FileAssetModalProps } from "../types"

interface InternalFormData {
  name: string
  note?: string
  fileList?: UploadFile[]
}

const { TextArea } = Input

const FileAssetModal = ({
  isOpen,
  fileAsset,
  loading,
  onClose,
  onSave,
}: FileAssetModalProps) => {
  const [form] = Form.useForm<InternalFormData>()

  useEffect(() => {
    if (isOpen && fileAsset) {
      form.setFieldsValue({
        name: fileAsset.name,
        note: fileAsset.note || undefined,
      })
      return
    }

    if (isOpen) {
      form.resetFields()
    }
  }, [fileAsset, form, isOpen])

  const handleSubmit = async () => {
    const values = await form.validateFields()
    const formData: FileAssetFormData = {
      name: values.name.trim(),
      note: values.note?.trim(),
      file: values.fileList?.[0]?.originFileObj as File | undefined,
    }
    onSave(formData)
  }

  return (
    <Modal
      title={fileAsset ? "编辑文件信息" : "上传文件"}
      open={isOpen}
      onOk={handleSubmit}
      onCancel={onClose}
      confirmLoading={loading}
      width={640}
      destroyOnHidden
      okText="确定"
      cancelText="取消"
    >
      <Form form={form} layout="vertical" preserve={false}>
        {!fileAsset && (
          <Form.Item
            name="fileList"
            label="上传文件"
            valuePropName="fileList"
            getValueFromEvent={(event) => event?.fileList}
            rules={[
              {
                validator: async (_, value?: UploadFile[]) => {
                  if (value && value.length > 0) {
                    return
                  }
                  throw new Error("请先选择文件")
                },
              },
            ]}
          >
            <Upload
              beforeUpload={() => false}
              maxCount={1}
              onChange={({ fileList }) => {
                const nextName = fileList[0]?.name
                if (nextName && !form.getFieldValue("name")) {
                  form.setFieldValue("name", nextName)
                }
              }}
            >
              <Button icon={<InboxOutlined />}>选择文件</Button>
            </Upload>
          </Form.Item>
        )}

        <Form.Item
          name="name"
          label="文件名称"
          rules={[{ required: true, message: "请输入文件名称" }]}
        >
          <Input placeholder="请输入文件名称" maxLength={200} />
        </Form.Item>

        <Form.Item name="note" label="备注">
          <TextArea
            rows={4}
            placeholder="请输入备注信息（可选）"
            maxLength={1000}
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default FileAssetModal
